<div class="row" style="height: 100vh">
  <div class="col-md-6 col-sm-12">
      <div class="row header-strip" style="z-index: 999;">
        <div class="logo">
          <a [routerLink]="['/']" class="logo-link">
            <img src="../../../assets/img/brand/Scriblr_Horizontal.png" alt="Inscribe" width="175"/>
          </a>
        </div>
    </div>
    <div class="content">
      <div class="row content-container">
        <div class="col-1"></div>
        <div class="col-10">
          <div class="introduction" style="z-index: 1;">
            <div class="app-slogan">
              Enter the new password
            </div>
            <div class="user-form">
              <div *ngIf="errorObject.showAlert">
                <alert [type]="errorObject.alertType" dismissible="true" (onClosed)="onAlertClosed(alert)">
                  <span [innerHtml]="errorObject.alertMsg"></span>
                </alert>
              </div>
              <form>
                <div class="form-group">
                  <input type="password" #password class="form-control" id="password" required [formControl]="passwordFormControl">
                  <span class="form-highlight"></span>
                  <span class="form-bar"></span>
                  <label for="password" class="float-label">Password</label>
                  <div class="invalid-input" *ngIf="passwordFormControl.invalid && (passwordFormControl.dirty || passwordFormControl.touched)">
                    Password <strong>cannot</strong> be <strong>blank</strong>
                  </div>
                </div>
                <div class="form-group">
                  <input type="password" class="form-control" id="confirmPassword" required [formControl]="confirmPasswordFormControl">
                  <span class="form-highlight"></span>
                  <span class="form-bar"></span>
                  <label for="confirmPassword" class="float-label">Confirm password</label>
                  <div class="invalid-input" *ngIf="confirmPasswordFormControl.invalid && (confirmPasswordFormControl.dirty || confirmPasswordFormControl.touched)">
                    Password <strong>cannot</strong> be <strong>blank</strong>
                  </div>
                </div>
                <button type="submit" class="btn btn-primary" (click)="resetPassword();" [disabled]="isRegistering">Reset Password
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isRegistering"></span>
                <span class="sr-only" *ngIf="isRegistering">Please wait...</span></button>
              </form>
            </div>
            <div style="margin-top:32px;">
                Go back to <a [routerLink]="['/signin']">Sign In</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6 d-none d-md-block front-dark">
    <div class="row">
      <div class="col-1"></div>
      <div class="col-10">
        <carousel style="margin-top: calc( 100vh/4);position: absolute;">
          <slide>
            <div class="text-center py-5 text-white">
              <div class="lead">
                <h3 class="slide-caption text-white">Avoid context switching</h3>
                <div class="app-description">
                  You don't need to leave the Scriblr app to check your references. Web pages, images, videos, audio, or documents, everything is available to you when you write so that your focus is unbroken.

                </div>
              </div>
            </div>
          </slide>
          <slide>
            <div class="text-center py-5 text-white">
              <div class="lead">
                <h3 class="slide-caption text-white">Keep all the references together</h3>
                <div class="app-description">
                  Never miss a reference. With the browser extensions, mobile, and web apps, gather everything that you need from anywhere. Everything is then available
                  from a single interface so that you don't have to worry about managing them using different tools and storing them at different places.
                </div>
              </div>
            </div>
          </slide>
          <slide>
            <div class="text-center py-5 text-white">
              <div class="lead">
                <h3 class="slide-caption text-white">Focused writing for efficient project completion</h3>
                <div class="app-description">
                  Distraction-free writing mode allows you to complete your writing projects sooner. Yet, the flexibility enables quick reference checks without breaking the focus.
                </div>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</div>
